import { render, staticRenderFns } from "./EditDoctor.vue?vue&type=template&id=477525d6&"
import script from "./EditDoctor.vue?vue&type=script&lang=js&"
export * from "./EditDoctor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports